import React from "react";
import "./Waitlist.scss";
import { Layout, PageHeader, Space, Button, Table, Modal, Select, message, Input, Grid, Card, Empty } from "antd";
import { useHistory } from "react-router";
import R2Footer from "../../../components/Footer";
import { EditOutlined, DeleteOutlined, PlusOutlined, BellOutlined,ExclamationCircleOutlined } from "@ant-design/icons";
import profileIcon from "../../../assets/images/profile.svg";
import { useState } from "react";
import { useEffect } from "react";
import PosService from "../../../services/PosService";
import { useSelector } from "react-redux";
import EmployeeService from "../../../services/EmployeeService";
import AddWaitlist from "./AddWaitlist";
import moment from "moment"
import Spinner from "../../../components/Layout/Spinner";
import { Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

const { Content } = Layout;
const { Option } = Select;
const { confirm } = Modal;
const {useBreakpoint} = Grid

const Waitlist = () => {
  const history = useHistory();
  const [isLoading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [rowData, setRowData] = useState({});
  const [section, setSectionData] = useState([]);
  const [server, setServer] = useState([]);
  const adminRestaurant = useSelector((state) => state.admin);
  const [employees, setEmployees] = useState([]);
  const [waitlists, setWaitlist] = useState([]);
  const [selectedType, setSelectedType] = useState("All");
  const screens = useBreakpoint();


  // useEffect(() => {section
  //   (async () => {
  //     const data = await PosService.getSectionWithFloor(adminRestaurant);
  //     const employee = await PosService.getEmployeeForPos(adminRestaurant);
  //     setServer(employee?.employees);
  //     const arr = [];
  //     data.map((val) => {
  //       const obj = {
  //         title: "Floor " + val.floor,
  //         value: val.floor,
  //         children: [],
  //       };
  //       val.section.map((section) => {
  //         obj.children.push({ title: "Section " + section, value: section });
  //       });
  //       arr.push(obj);
  //     });
  //     setSectionData(arr);
  //   })();
  // }, []);

  const closeModal = () => {
    setModalOpen(false);
  };
  useEffect(() => {
    getWaitlist();
  }, [adminRestaurant]);

  const getWaitlist = async () => {
    setLoading(true)
    const data = await PosService.posWaitlist(adminRestaurant)
    setEmployees(data.waitlist?.map(item=> {return {...item,est:moment(item.created_at).format("hh:mm:ss a")}}));
    setWaitlist(data.waitlist?.map(item=> {return {...item,est:moment(item.created_at).format("hh:mm:ss a")}}))
    setLoading(false)
  };
  const handleChange = async(value,id) => {
    console.log(`selected ${value}`);
  
   
  };
  const columns = [
    // {
    //   title: "",
    //   dataIndex: "",
    //   key: "",
    //   width:100,
    //   render: (_, record) => {
    //     return (
    //       <div>
    //         <Avatar size="large" style={{marginRight:'10px'}}>{record.name[0]}</Avatar>
           
    //       </div>
    //     );
    //   },
    // },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (_, record) => {
        return (
          <div style={{ display: "flex" }} >
            <div  className="name_text">
              {record.name}
            </div>
          </div>
        );
      },
    },
    {
        title: "Email",
        dataIndex: "name",
        key: "name",
        render: (_, record) => {
          return (
            <div style={{ display: "flex" }} >
              <div  className="name_text">
                {record.email}
              </div>
            </div>
          );
        },
      },
      {
        title: "Phone No",
        dataIndex: "name",
        key: "name",
        render: (_, record) => {
          return (
            <div style={{ display: "flex" }} >
              <div  className="name_text">
                {record.phone}
              </div>
            </div>
          );
        },
      },
      {
        title: "No. of People",
        dataIndex: "name",
        key: "name",
        render: (_, record) => {
          return (
            <div style={{ display: "flex" }} >
              <div  className="name_text">
                {record.num_people}
              </div>
            </div>
          );
        },
      },
      {
        title: <div> EWT  <Tooltip title="Estimated waiting time.">
        <InfoCircleOutlined style={{ color: '#C32340', marginLeft: 8, cursor: 'pointer' }} />
      </Tooltip></div>,
        dataIndex: "name",
        key: "name",
        render: (_, record) => {
          return (
            <div style={{ display: "flex" }} >
              <div  className="name_text">
                <Input value={record.est_wait_time_min} className="ewt-input"
                onChange={(e)=>ewtOnchange(record,e)}/>
                
              </div>
            </div>
          );
        },
      },
      {
        title: <div> EST  <Tooltip title="Estimated service time.">
        <InfoCircleOutlined style={{ color: '#C32340', marginLeft: 8, cursor: 'pointer' }} />
      </Tooltip></div>,
        dataIndex: "name",
        key: "name",
        render: (_, record) => {
          return (
            <div style={{ display: "flex" }} >
              <div  className="name_text">
                {record.est}
               
              </div>
            </div>
          );
        },
      },
    
   
    {
      title: "",
      render: (_, record) => {
        return (
          <div
            style={{
              display: "flex",
            }}
          >
            <>
              <EditOutlined
                onClick={(e) => {
                  e.stopPropagation();
                  if(record?.updated)
                  {
                  setRowData(record);
                  updateEWT(record)
                  }
                  // setModalOpen(true);
                }}
                style={{color: record?.updated ? '#000000':'#d0d7d0'}}
                
              />{" "}
              <BellOutlined style={{ fontSize: '19px', color: 'yellow',marginLeft:"5px" }}/>
              <DeleteOutlined style={{ fontSize: '19px', color: 'red',marginLeft:"5px" }}
              onClick={(e)=>{
                e.stopPropagation();
                handleDelete(record)
              }}/>
            </>
          </div>
        );
      },
    },
  ];
  const updateEWT = async(record)=>{

    const ewt = employees.find(item=> item.id == record.id)
    
    const payload ={
      est_wait_time_min : Number(ewt?.est_wait_time_min)
    }
    setLoading(true)
    const dataList = await PosService.updateWaitlistEWT(adminRestaurant,record.id,payload)
    if(dataList)
    message.success("updated successfully")
    else
    message.error("Please try later")
    setLoading(false)
  }

  const ewtOnchange =(record,e)=>{
     const waitlistItems = employees.map(item=>{
    const created=  moment(item.created_at).format("hh:mm:ss a")
      if(record.id == item.id)
        return{
            ...item,
            est_wait_time_min: e.target.value,
            est:moment(created,"hh:mm:ss a").add(Number(e.target.value), 'minutes').format("hh:mm:ss"),
            updated: true,
         }
         else
         return item;
     })
     setEmployees(waitlistItems)
  }
  const handleDelete = (record) => {
    confirm({
      title: 'Are you sure to delete?',
      icon: <ExclamationCircleOutlined />,
      content: ' This action cannot be undone.',
  
      onOk() {
        deleteProvider(record)
      },
  
      onCancel() {
        console.log('Cancel');
      },
    });
  };

  const deleteProvider = async(record)=>{
    const dataList = await PosService.deleteWaitlist(adminRestaurant,record.id)
    message.success("Deleted successfully")
    getWaitlist()
  }

  return (
    <Layout className={`${screens.md && "u-page-layout"}`}>
      <Content className="w-full page-padding">
        <Space direction="vertical" style={{ width: "100%" }}>
          <PageHeader
          className={screens.md ? "page-header" : "page-header header-waitlist-mobile"}
            title={
              <div className={ "flex space-between"}>
              <div>Waitlist</div>
              {!screens.md &&
               <Button type="text" icon={<PlusOutlined/>} danger className="addparties-btn"
                    onClick={(e) => {
                        e.stopPropagation();
                        setModalOpen(true);
                      }}>
      Add Parties
    </Button>
    }
    </div>
              }
            extra={[
                <div>
                  {screens.md &&
                   <Button type="text" icon={<PlusOutlined/>} danger className="addparties-btn"
                    onClick={(e) => {
                        e.stopPropagation();
                        setModalOpen(true);
                      }}>
      Add Parties
    </Button>
    }
              <Button
                type="primary"
                className={selectedType == "All"? "selected-waitlist pos-radio-button":"not-selected-waitlist pos-radio-button"}
                onClick={() => {
                  setSelectedType("All")
                  setEmployees(waitlists)
                }}
              >
                All Parties
              </Button>
              <Button
                type="primary"
                className={selectedType == "New"? "selected-waitlist online-radio-button":"not-selected-waitlist online-radio-button"}

                onClick={() => {
                  setSelectedType("New")
                  setEmployees(waitlists.filter(item=> item.est_wait_time_min == null))
                }}
              >
                New Parties
              </Button>
              </div>,
            ]}
          />
          {screens.md ?
          <Table
            columns={columns}
            dataSource={employees}
            className="discount-table waitlist-table overflow-auto"
          />
          :
          employees.length == 0 ?
           <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
          :
          employees.map((record)=>
          <Card className="waitlist-card">
            <div className="flex space-between">
                        <div style={{fontSize:"14px", fontWeight:"500"}}> {record.name} </div>{" "}
                        <div> 
                           <div
            style={{
              display: "flex",
            }}
          >
            <>
              <EditOutlined
                onClick={(e) => {
                  e.stopPropagation();
                  if(record?.updated)
                  {
                  setRowData(record);
                  updateEWT(record)
                  }
                  // setModalOpen(true);
                }}
                style={{color: record?.updated ? '#000000':'#d0d7d0'}}
                
              />{" "}
              <BellOutlined style={{ fontSize: '19px', color: 'yellow',marginLeft:"5px" }}/>
              <DeleteOutlined style={{ fontSize: '19px', color: 'red',marginLeft:"5px" }}
              onClick={(e)=>{
                e.stopPropagation();
                handleDelete(record)
              }}/>
            </>
          </div></div>
                      </div>

                      <div className="flex space-between">
                        <div>EWT <Tooltip title="Estimated waiting time.">
        <InfoCircleOutlined style={{ color: '#C32340', marginLeft: 8, cursor: 'pointer' }} />
      </Tooltip> </div>
                        <div style={{ display: "flex" }} >
              <div  className="name_text">
                <Input value={record.est_wait_time_min} className="ewt-input"
                onChange={(e)=>ewtOnchange(record,e)}/>
                
              </div>
            </div>
                      </div>

                      <div className="flex space-between">
                        <div>No.of People </div>
                        <div> {record?.num_people}</div>
                      </div>

                      <div className="flex space-between">
                        <div> EST  <Tooltip title="Estimated service time.">
        <InfoCircleOutlined style={{ color: '#C32340', marginLeft: 8, cursor: 'pointer' }} />
      </Tooltip></div>
                        <div> {record?.est}</div>
                      </div>

                      <div className="flex space-between">
                        <div>Email </div>
                        <div> {record?.email}</div>
                      </div>

                      <div className="flex space-between">
                        <div>Phone Number </div>
                        <div> {record?.phone}</div>
                      </div>
          </Card>
          )
}
        </Space>
      </Content>
      <R2Footer />
      <AddWaitlist
        modalOpen={modalOpen}
        closeModal={closeModal}
        
      />
      {isLoading &&
      <Spinner/>
}
    </Layout>
  );
};

export default Waitlist;
